import { onBeforeMount, ComponentInstance } from "@vue/composition-api";

const useGetTableLibs = (root: ComponentInstance): void => {
  const store = root.$store;

  onBeforeMount(() => {
    store.dispatch("historicalNotesView/getKind");
  });
};

export default useGetTableLibs;
